import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Building2, FileText, Phone, Mail } from 'lucide-react';
import Footer from './Footer';
import './Contacts.css';

function Contacts() {
  const navigate = useNavigate();

  // Скролл вверх при открытии страницы
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="contacts-page">
      {/* Header */}
      <header className="contacts-header">
        <div className="contacts-header-content">
          <Link to="/" className="contacts-logo">
            <img src="/logo.png" alt="Pikly" />
            <span>PIKLY</span>
          </Link>
          <div className="contacts-header-actions">
            <Link to="/register" className="btn ghost">Регистрация</Link>
            <Link to="/login" className="btn primary">Вход</Link>
          </div>
        </div>
      </header>

      <div className="contacts-container">
        <div className="contacts-content">
          <h1>Контакты</h1>
          
          <section className="contacts-section">
            <h2>
              <Building2 size={20} />
              Информация об организации
            </h2>
            <div className="contacts-info">
              <div className="info-item">
                <strong>ООО "САХА КОНТЕНТ"</strong>
                <p>ИНН 1400007690, ОГРН 1221400004297</p>
                <p>Регистрационный номер 14-25-002616 в Реестре операторов РКН</p>
              </div>
            </div>
          </section>

          <section className="contacts-section">
            <h2>
              <Phone size={20} />
              Связь с нами
            </h2>
            <div className="contacts-links">
              <a 
                href="https://t.me/selfai_support" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                Техническая поддержка: @selfai_support
              </a>
              <a 
                href="https://t.me/selfai_support" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                Для рекламодателей: @selfai_support
              </a>
              <a 
                href="mailto:olbu.inbox@yandex.ru"
                className="contact-link"
              >
                <Mail size={18} />
                Email: olbu.inbox@yandex.ru
              </a>
            </div>
          </section>

          <section className="contacts-section">
            <h2>
              <FileText size={20} />
              Документы
            </h2>
            <div className="contacts-documents">
              <a 
                href="/public_offer.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="document-link"
              >
                Публичная оферта
              </a>
              <a 
                href="/privacy_policy.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="document-link"
              >
                Политика обработки персональных данных
              </a>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contacts;
